// @flow
import React, { Component } from "react";
import withStyles from "elevate-ui/withStyles";
import { withGlobalContext } from "../../../common/GlobalContext";
import enhanceWithClickOutside from "react-click-outside";
import classNames from "classnames";

import type { $Site } from "flow/types";

import RenderLogo from "../../RenderLogo";
import RenderContactInfo from "../../RenderContactInfo";
import RenderNav from "../../RenderNav";

type $Props = {
  classes: Object,
  onCloseDropdown: Function,
  compliance: Object,
  onToggleDropdown: Function,
  openDropdowns: Object,
  site: $Site,
};

class ThreeColumnNavBar extends Component<$Props> {
  handleClickOutside() {
    this.props.onCloseDropdown();
  }
  render() {
    const { classes, compliance } = this.props;
    return (
      <header
        className={classNames(classes.root, {
          [classes.stickyHeaderMargin]:
            compliance &&
            (compliance.stickyHeader ||
              compliance.stickyHeaderCustom ||
              compliance.stickyHeaderMobile),
          [classes.stickerHeaderMarginLarge]:
            compliance &&
            (compliance.stickyHeader || compliance.stickyHeaderMobile) &&
            compliance.stickyHeaderCustom,
        })}
      >
        <div className={classes.brandBar}>
          <div className={classes.logoContainer}>
            <div>
              <RenderLogo />
            </div>
          </div>
          <div className={classes.agentInfo}>
            <RenderContactInfo />
          </div>
        </div>
        <div className={classes.navBarContainer}>
          <RenderNav />
        </div>
      </header>
    );
  }
}

const styles = (theme) => {
  return {
    "@global": {
      "header a svg, header li svg": {
        verticalAlign: "top",
        marginTop: "-2px",
      },
    },
    root: {
      display: "flex",
      position: "relative",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      paddingTop: "0",
      backgroundColor: theme.colors.secondary["500"],
      [theme.breakpoints(900)]: {
        zIndex: theme.zIndex["header"],
        paddingTop: theme.spacing.unit * 0.75,
      },
    },
    brandBar: {
      display: "none",
      [theme.breakpoints(900)]: {
        flex: "0 0 auto",
        display: "flex",
        position: "relative",
        flexFlow: "row nowrap",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        maxWidth: "970px",
        paddingBottom: theme.spacing.unit * 0.75,
      },
    },
    logoContainer: {
      flex: "0 1 auto",
      display: "flex",
      position: "relative",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      "& div img": {
        display: "block",
        maxWidth: "300px",
        width: "auto",
        height: "auto",
        maxHeight: "80px",
      },
    },
    agentInfo: {
      textAlign: "center",
      fontSize: "14px",
      lineHeight: "14px",
      color: theme.colors.secondaryFontColor,
      "& a": {
        color: theme.colors.secondaryFontColor,
      },
    },
    navBarContainer: {
      display: "flex",
      position: "relative",
      flexFlow: "row wrap",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      backgroundColor: theme.colors.primary["500"],
    },
    stickyHeaderMargin: {
      marginTop: theme.spacing.unit * 2,
      paddingTop: theme.spacing.unit * 1.5,
    },
    stickerHeaderMarginLarge: {
      marginTop: theme.spacing.unit * 4,
    },
  };
};

export default withGlobalContext(
  withStyles(styles)(enhanceWithClickOutside(ThreeColumnNavBar))
);
